import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getApplicationsByCourse = (token, courseId) =>
    apiClient.get("/api/student-applications/by-course", {
        headers: { Authorization: `Bearer ${token}` },
        params: { courseId }
    });


export const getAllStudentApplications = (token) =>
    apiClient.get("/api/student-applications/get-all", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const unlockRegistration = (unlockRequest, token) =>
    apiClient.patch("/api/student-applications/unlock", unlockRequest, {
        headers: { Authorization: `Bearer ${token}` },
    });



export const getStudentDetailsById = (studentIds, token) =>
    apiClient.get("/details", studentIds, {
        headers: { Authorization: `Bearer ${token}` },
    });